import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import { SectionHeader, type SectionTab } from "../../components/SectionHeader.js";
import {
  HeaderActionContext,
  useHeaderActionTarget,
} from "./HeaderActionSlot.js";

/**
 * Five-tab admin shell. Knowledge moved to /documentation, staff users
 * moved to /admin, audit + workflows folded into Settings or removed.
 * The customer-facing portal at support.xopnetworks.com is a separate surface
 * and isn't affected by this layout.
 *
 * Title + tab chrome come from the shared `<SectionHeader>` so every
 * dashboard section reads as one designed system. Sub-pages drop their
 * primary action (e.g. "+ New ticket") into the header's right slot via
 * `<HeaderAction>`.
 *
 * Conversations is the staff-side history of the Otto chat-bot — captured
 * live from chat-bot and surfaced here so staff can see what customers are
 * asking, flag bad answers, or escalate a stuck thread into a ticket.
 */
const TABS: SectionTab[] = [
  { to: "tickets",       label: "Tickets" },
  { to: "conversations", label: "Conversations" },
  { to: "organizations", label: "Organizations" },
  { to: "reports",       label: "Reports" },
  { to: "settings",      label: "Settings" },
];

export function SupportLayout(): JSX.Element {
  const [slotEl, setSlotEl] = useHeaderActionTarget();

  return (
    <HeaderActionContext.Provider value={slotEl}>
      <>
        <SectionHeader
          title="Customer Support"
          tabs={TABS}
          tabsAriaLabel="Support sections"
          right={<Box ref={setSlotEl} sx={{ display: "flex", alignItems: "center", gap: 1 }} />}
        />
        <Outlet />
      </>
    </HeaderActionContext.Provider>
  );
}
